import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'casesColor'
})
export class CasesColorPipe implements PipeTransform {

  getColorOfCase(name: string,  property: string = null): any {
    const result = { class: '', color: '' };
    switch (name) {
      case 'Open':
        result.class = 'blue';
        result.color = '#2277ED';
        break;
      case 'Solved':
        result.class = 'green';
        result.color = '#1EE994';
        break;
      case 'Reported':
      case 'Overdue':
        result.class = 'violet';
        result.color = '#4626A6';
        break;
      default:
        result.class = 'red';
        result.color = '#FF0000';
    }
    return property ? result[property] : result;
  }

  transform(name: string, property: string = null): any {
    return this.getColorOfCase(name, property);
  }
}
